import React, { useContext } from 'react';
import { Row, Col, Card as RBCard } from "react-bootstrap";
import {
  Box,
  Container,
  Typography,
  Avatar,
  Button
} from "@mui/material";
import "../../Commonmodel/Common.css";
import { authHttp } from '../../../services/commonHttpService';
import { apisPath } from "../../../utils/path";
import ApartmentIcon from "@mui/icons-material/Apartment";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from '@mui/icons-material/People';
import { AuthContext } from '../../../context/AuthContext';
import { CommonContext } from '../../../context/CommonContext';
import { downloadBlob } from '../../../helpers/commonHelper';
import PdfIcon from "../../Images/pdf-icon.svg";
import XlsIcon from "../../Images/xls-icon.svg";
import dayjs from "dayjs";
import DashboardCards from '../../../shared/DashboardCards/DashboardCards';
import { executeDownload } from '../../../helpers/commonHelper';

const StateCredDownload = () => {
  const { userStateId, userStateName } = useContext(AuthContext);
  const { setIsLoading, setSnackState } = useContext(CommonContext);

  const cardConfig = [
    {
      id: 1,
      title: "TCCC Credentials",
      icon: <BusinessIcon sx={{ color: "#6C7FF9" }} />,
      isCredentials: true,
      facilityType: 'MI'
    },
    {
      id: 2,
      title: "DCCC Credentials",
      icon: <ApartmentIcon sx={{ color: "#6C7FF9" }} />,
      isCredentials: true,
      facilityType: 'DCCC'
    }
  ];

  const generateButtons = (card) => {
    if (card.isCredentials) {
      return [{
        label: "Download",
        className: "dwnBtnAdmin",
        onClick: () => {
          const fileName = `${card.facilityType === 'MI' ? 'TCCC' : 'DCCC'}_${userStateName || ""}_Credentials.xlsx`;
          executeDownload(apisPath?.stateCredentialsDownload, {
            facility_type: card.facilityType,
            state_lgd: userStateId
          }, fileName, setIsLoading, setSnackState);
        }
      }];
    }
  };

  const dashboardCards = cardConfig.map(card => ({
    ...card,
    buttons: generateButtons(card)
  }));

  return (
    <>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid #E6E6E6", // light grey line
          py: 2,
        }}
      >
        <Container>
          {/* Title */}
          <Typography variant="h6" fontWeight="600">
            Day Care Cancer Center
          </Typography>

          {/* Subtitle */}
          <Typography variant="body2" color="gray" sx={{ mt: 0.3 }}>
            State Cancer Care Program - Comprehensive Overview
          </Typography>
        </Container>
      </Box>
      <Container>
        <Typography variant="h6" fontWeight={600} className="mt-3">
          State-Wise Credential Download
        </Typography>

        <DashboardCards cards={dashboardCards} />
      </Container>
    </>
  )
}

export default StateCredDownload